import { initDesktopSearch } from './search-desktop';
import { initTopAccount } from './account';
import { initTopMenuDesktop } from './top-menu-desktop';
import { initTopMiniCart } from './top-minicart';
import { initTopMobile } from './top-menu-mobile';
import { initMobileSearch } from './search-mobile';
import { initSbsPaymentFailedMobile } from './sbs-payment-failed-mobile';
import { sendGAEvent } from '../../domain/marketing/gtm-provider';
import { getIsAuthenticated } from '../../domain/hidden-data-provider';
import { initNotifications } from './notifications';
import { getPersonalizationProperty } from '../personalization/domain/personalization-provider';
import { initMobileMenuAksWaves, initTabletMenuAksWaves } from './ask-waves/mobile-menu-ask-waves';

const OPENED_IN_SESSION = 'sbs-payment-failed-view-event';

const initSticky = () => {
    const supported = 'IntersectionObserver' in window;
    if(!supported) return;

    const $header = document.getElementById('site-header');
    if(!$header) return;

    const $sensor = document.getElementById('sticky-header-sensor');
    if(!$sensor) return;

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            // entry.target.classList.toggle('site-header-sticky', !entry.isIntersecting);
            $header.classList.toggle('site-header-sticky', !entry.isIntersecting);
            document.body.classList.toggle('sticky-mode', !entry.isIntersecting);
        });
    }, {
        // The element that is used as the viewport for checking visibility of the target.
        // Must be the ancestor of the target.
        // Defaults to the browser viewport if not specified or if null.
        root: null,

        // Margin around the root.
        // Can have values similar to the CSS margin property, e.g. "10px 20px 30px 40px" (top, right, bottom, left).
        // The values can be percentages.
        // This set of values serves to grow or shrink each side of the root element's bounding box before computing intersections.
        // Defaults to all zeros.
        rootMargin: '0px',

        // Either a single number or an array of numbers which indicate at what percentage of the target's visibility the observer's callback should be executed. If you only want to detect when visibility passes the 50% mark, you can use a value of 0.5. If you want the callback to run every time visibility passes another 25%, you would specify the array [0, 0.25, 0.5, 0.75, 1]. The default is 0 (meaning as soon as even one pixel is visible, the callback will be run). A value of 1.0 means that the threshold isn't considered passed until every pixel is visible.
        threshold: [0.5], // 0.1, 1
    });

    observer.observe($sensor);
};

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-4467
 * Action = “SBS Payment Issue” / Label  = “View Message” – happens one time per session
 */
const sendSbsPaymentIssueEvent = () => {
    const isLoggedIn = getIsAuthenticated();
    if(!isLoggedIn) return;

    const userHasSbsPaymentIssue = getPersonalizationProperty('hasSBSPaymentIssue') as boolean;
    if(!userHasSbsPaymentIssue) return;

    if(window.sessionStorage.getItem(OPENED_IN_SESSION) === 'true') return;

    sendGAEvent('SBS Payment Issue', 'View Message');
    window.sessionStorage.setItem(OPENED_IN_SESSION, 'true');
};

const initHeader = () => {

    // top menu -------------------------------------
    initTopMenuDesktop();
    initTopMobile();

    // search  --------------------------------------
    initDesktopSearch();
    initMobileSearch();

    // account --------------------------------------
    initTopAccount();

    // top mini-cart --------------------------------
    initTopMiniCart();

    // https://wavesaudio.atlassian.net/browse/DSWEB-4467
    initSbsPaymentFailedMobile();
    sendSbsPaymentIssueEvent();

    // https://wavesaudio.atlassian.net/browse/DSWEB-4663
    initNotifications();

    // Ask waves mobile --------------
    // https://wavesaudio.atlassian.net/browse/DSWEB-5501
    initMobileMenuAksWaves();
    initTabletMenuAksWaves();

    initSticky();
};

document.addEventListener('DOMContentLoaded', () => {
    initHeader();
});